<template>
  <!-- 赢取好礼 -->
  <section id="rewards" class="rewards">
    <div class="l-center">
      <h2 class="title"></h2>
      <!-- 全民参与奖 -->
      <div class="participation-award">
        <h3 class="ff--trajanpro-bold">
          {{ locale.participationReward }}
        </h3>
        <p>{{ locale.enterCode }}</p>
        <div class="cdk">
          <div class="cdk__content text-ellipsis">
            {{ code }}
          </div>
          <div v-gtag:copyCode id="copy" data-type="button" class="copy"></div>
        </div>
      </div>
      <!-- 任务刮刮乐 -->
      <div class="lucky-game">
        <h3 class="lucky-game__title ff--trajanpro-bold">
          {{ locale.questScratchcards }}
        </h3>
        <p class="lucky-game__descr">
          <span>{{ locale.winAmazonCards }}</span><br />
          <!-- <span>{{ locale.completeGetMore }}</span
          ><br /> -->
          <span>{{ locale.scratch5cards }}</span>
        </p>
        <div class="lucky-game-content">
          <div class="lucky-game-content__inner" :class="{
            'lucky-game-content--disabled': isDisabled && !isDrawing,
          }">
            <div class="award" :class="{ sorry: !round }">
              <template v-if="round">
                <img src="~images/kv/award_4.png" alt="award" />
                <span>amazon card ${{ round }}</span>
              </template>
              <span v-else class="ff--trajanpro-bold">{{
                $locale.dialog.award.sorry
              }}</span>
            </div>
            <img class="mask" src="~images/rewards/game_mask.png" id="redux" />
          </div>
          <span v-if="isDrawing" data-type="button" class="skip ff--trajanpro-bold" @click="skip">SKIP</span>
          <div class="draw-start" v-loading="loading" element-loading-text="loading..."
            element-loading-background="rgba(0,0,0,.4)" :style="isDrawing ? 'pointer-events: none' : ''">
            <div v-gtag:scratch data-type="button" :class="['dialog-btn', isDisabled && 'is-disabled']"
              @click.stop="draw">
              <span>{{ locale.draw.scratch }}</span>
            </div>
            <span class="text ff--trajanpro-bold">{{ locale.draw.chancesRemaining }}: {{ times }}</span>
          </div>
        </div>
        <div class="table complete-list ff--trajanpro-bold">
          <div class="thead">
            <div class="row">
              <div class="col">{{ locale.task.method }}</div>
              <div class="col">{{ locale.task.chancesEarned }}</div>
              <div class="col">{{ locale.task.progress }}</div>
            </div>
          </div>
          <div class="tbody">
            <div class="row">
              <div class="col">{{ locale.task.loginGame }}</div>
              <div class="col">{{ Number(taskStatus.isLogin) }}/1</div>
              <div class="col">
                <template v-if="taskStatus.isLogin">
                  {{ locale.task.completed }}
                </template>
                <template v-else>
                  {{ locale.task.notCompleted }}
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col">{{ locale.task.sharePage }}</div>
              <div class="col">{{ Number(taskStatus.isShare) }}/1</div>
              <div class="col">
                <template v-if="taskStatus.isShare">
                  {{ locale.task.completed }}
                </template>
                <template v-else>
                  <span class="progress highlight" data-type="link" @click="doTask('share', 'open')">{{
                    locale.task.toShare }}</span>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col">{{ locale.task.chooseCivi }}</div>
              <div class="col">{{ Number(taskStatus.isJoined) }}/1</div>
              <div class="col">
                <template v-if="taskStatus.isJoined">
                  {{ locale.task.completed }}
                </template>
                <template v-else>
                  <span data-type="link" class="progress highlight" @click="doTask('join')">{{ locale.task.toJoin
                  }}</span>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col">{{ locale.task.reachLv8 }}</div>
              <div class="col">{{ Number(taskStatus.isReachlv8) }}/1</div>
              <div class="col">
                level
                {{
                  (userInfo &&
                    userInfo.user_info &&
                    userInfo.user_info.town_center_level) ||
                  0
                }}
              </div>
            </div>
            <div class="row">
              <div class="col">{{ locale.task.researchPathfinding }}</div>
              <div class="col">{{ Number(taskStatus.isResearchPathfinding) }}/1</div>
              <div class="col">
                {{
                  taskStatus.isResearchPathfinding
                  ? locale.task.completed
                  : locale.task.notCompleted
                }}
              </div>
            </div>
            <div class="row">
              <div class="col">{{ locale.task.reach10000 }}</div>
              <div class="col">{{ Number(taskStatus.isReach10k) }}/1</div>
              <div class="col">
                {{
                  (userInfo && userInfo.user_info && userInfo.mission_combat_power) || 0
                }}
              </div>
            </div>
          </div>
        </div>
        <div v-gtag:refresh data-type="link" class="refresh ff--trajanpro-bold" :class="{ 'is-refresh': isRefresh }"
          @click="refresh">
          Refresh
        </div>
        <div v-gtag:prizeHistory class="winning-record ff--trajanpro-bold" data-type="link" @click="record('open')">
          <span>{{ locale.draw.prizeHistory }}</span>
        </div>
      </div>
    </div>

    <DlgShare :visible="shareVisible" @close="doTask('share', 'close')" />
    <DlgAward :round="round" :visible="visible" @close="award('close')" />
    <DlgRecords :uid="uid" :visible="recordVisible" @close="record('close')" />
  </section>
</template>

<script>
import DlgShare from "components/dialog/share.vue";
import DlgAward from "components/dialog/award.vue";
import DlgRecords from "components/dialog/records.vue";
import { mapActions, mapGetters } from "vuex";
import cfgData from "scripts/constants/configData";
import { CopyText } from "scripts/util";

let refreshTimer = null;
export default {
  name: "Game",
  components: {
    DlgAward,
    DlgRecords,
    DlgShare,
  },
  data() {
    return {
      taskList: cfgData.taskList,
      code: cfgData.code,
      times: 0,
      isDrawing: false,
      visible: false,
      shareVisible: false,
      recordVisible: false,
      locale: this.$locale.rewards,
      round: 0,
      isRefresh: false,
      loading: false,

      // 任务状态
      taskStatus: {
        isLogin: false,
        isShare: false,
        isJoined: false,
        isReachlv8: false,
        isResearchPathfinding: false,
        isReach10k: false,
      },
      uid: "",
    };
  },
  created() { },
  mounted() {
    console.log("");
    CopyText("#copy", this.code);
  },
  watch: {
    userInfo: {
      handler(val) {
        this.times = val.raffle_count || 0;
        this.taskStatus.isLogin = !!val.is_login;
        this.taskStatus.isShare = !!val.is_share;
        this.taskStatus.isJoined = !!val.user_info?.guild;
        this.taskStatus.isReachlv8 = !!val.mission_town_center;
        this.taskStatus.isResearchPathfinding = !!val.mission_tech;
        this.taskStatus.isReach10k = !!val.mission_power;
        this.uid = val.user_info?.uuid;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["isLogin", "userInfo", "isJoinCivi"]),
    isDisabled() {
      return this.times <= 0;
    },
  },
  methods: {
    ...mapActions(["raffle", "refreshTaskStatus"]),
    refresh() {
      if (!this.isLogin) {
        this.$login.$emit("open");
        return;
      }
      this.isRefresh = true;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        this.refreshTaskStatus().finally((res) => {
          this.isRefresh = false;
        });
      }, 200);
    },
    doTask(type, ...rest) {
      const taskType = {
        share: (action) => {
          if (!this.isLogin) {
            this.$login.$emit("open");
            return;
          }
          if (action == "open") {
            this.shareVisible = true;
          } else if (action == "close") {
            this.shareVisible = false;
          }
        },
        join: () => {
          $("html").animate({
            scrollTop: $("#join").offset().top - $("#header").height(),
          });
        },
      };

      taskType[type]?.apply(this, rest);
    },
    // 是否超出边界
    isBeyondBoundary(cx, cy) {
      const luckyGame = $("#rewards .lucky-game-content");
      let { top, left } = luckyGame.get(0).getBoundingClientRect();
      const w = luckyGame.width(),
        h = luckyGame.height();
      return cx < left || cx > left + w || cy < top || cy > top + h;
    },
    // 奖励结果
    getRewardRes() {
      this.isDrawing = false;
      this.$nextTick(() => {
        $("#redux").eraser("reset");
      });
      this.award("open");
    },
    // 刮刮乐
    draw() {
      this.$message({
        message: this.$locale.toast.eventsEnded,
        duration: 3000,
      });
      return;

      if (this.loading) {
        return;
      }
      // 未登录
      if (!this.isLogin) {
        this.$login.$emit("open");
        return;
      }
      // 未加入文明
      if (!this.isJoinCivi) {
        this.$message(this.locale.joinCiviFirst);
        return;
      }
      if (this.userInfo.raffle_today == 5) {
        this.$message(this.locale.scratch5cards);
        return;
      }
      if (this.times <= 0) {
        this.$message(this.locale.completeGetMore);
        return;
      }

      this.loading = true;
      this.raffle()
        .then((res) => {
          this.round = res.round;
          this.startGame();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 跳过，直接展示奖励
    skip() {
      this.getRewardRes();
    },
    // 开始刮卡
    startGame() {
      const luckyGame = $("#rewards .lucky-game-content");
      this.isDrawing = true;
      $("#redux").eraser("reset");
      $("#redux").eraser({
        size: 60,
        completeRatio: 0.5,
        completeFunction: () => {
          if (this.isDrawing) {
            this.getRewardRes();
          }
        },
      });
      let n = 0;
      luckyGame
        .on("mousedown", (ev) => {
          $("body")
            .on("mousemove", () => { })
            .on("mousemove mouseup", (ev) => {
              if (!this.isDrawing) {
                return;
              }
              const { clientX: cx, clientY: cy } = ev;
              if (this.isBeyondBoundary(cx, cy)) {
                this.getRewardRes();
              }
            })
            .on("mouseup", () => {
              $("body").off("mousemove mouseup");
            });
        })
        .on("mouseup", () => {
          $("body").off("mousemove mouseup");
        });
    },
    award(action) {
      if (action == "open") {
        this.visible = true;
      } else if (action == "close") {
        this.visible = false;
      }
    },
    record(action) {
      if (!this.isLogin) {
        this.$login.$emit("open");
        return;
      }
      if (action == "open") {
        this.recordVisible = true;
      } else if (action == "close") {
        this.recordVisible = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.progress {
  display: inline-block;
}

.highlight {
  color: #ddd95c;
}
</style>

<style lang="less" scoped>
#rewards {
  position: relative;
  margin-top: -39px;
  height: 1840px;
  background: url(~images/rewards/bg2.png) no-repeat 0 0;
  background-size: 100% 1267px;
  z-index: 1;

  .l-center {
    padding-top: 158px;
  }

  .title {
    margin-bottom: 60px;
    height: 71px;
    background: url(~images/title/rewards.png) no-repeat 0 center;
    background-size: 100% auto;
  }

  .participation-award {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: auto;

    h3 {
      position: relative;
      left: 110px;
      align-self: center;
      margin-bottom: 18px;
      font-size: 40px;
      color: #ffffea;
      text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.84);
      text-align: center;
    }

    p {
      // width: 946px;
      height: 56px;
      margin-bottom: 23px;
      margin-left: auto;
      padding: 0 20px;
      background-color: #d8be98b2;
      border-radius: 28px;
      font-size: 28px;
      font-weight: bold;
      line-height: 56px;
      color: #724634;
    }

    .cdk {
      position: relative;
      left: -110px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 30px 25px 0;
      height: 72px;

      .cdk__content {
        width: 424px;
        height: 56px;
        padding: 0 20px;
        background: #6a4b26 linear-gradient(90deg, #7c5f3c 0%, #6a4b26 100%);
        border-radius: 4px;
        font-size: 30px;
        font-weight: bold;
        line-height: 56px;
        color: #fff;
        text-align: center;
      }

      .copy {
        margin-left: 28px;
        width: 162px;
        height: 72px;
        background: url(~images/rewards/btn_copy.png) no-repeat 0 center;
        background-size: 100% auto;
      }
    }
  }

  .lucky-game {
    position: relative;
    width: 856px;
    // min-height: 1148px;
    height: auto;
    margin-left: auto;
    padding-bottom: 48px;
    padding-right: 24px;
    background: url(~images/rewards/task_bg.png) no-repeat 0 0;
    background-size: 100% 100%;

    &__title {
      margin: 0 auto;
      width: 589px;
      height: 123px;
      line-height: 123px;
      font-size: 48px;
      color: var(--primary-color);
      text-align: center;
      text-shadow: 1px 1px 0 rgba(57, 46, 32, 0.54);

      // background: url(~images/rewards/title_2.png) no-repeat center center;
      // background-size: auto 100%;
    }

    &__descr {
      margin: 28px auto 35px;
      padding: 0 60px;
      font-size: 24px;
      // line-height: 168px;
      color: var(--primary-color);
      text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54);
      text-align: center;

      em {
        font-style: normal;
        color: #e6bf2f;
      }
    }
  }

  .lucky-game-content {
    position: relative;
    margin: 0 auto 26px;
    width: 727px;
    height: 334px;

    &__inner {
      width: 100%;
      height: 100%;
      background: url(~images/rewards/game_bg.png) no-repeat center center;
      background-size: 100% auto;
    }

    &--disabled {
      // filter: grayscale(100%);
      background: url(~images/rewards/game_mask_2.png) no-repeat 40px 18px,
        url(~images/rewards/game_bg_2.png) no-repeat center center;
      background-size: 404px 294px, 100% auto;

      .award,
      ::v-deep .mask {
        opacity: 0;
      }
    }

    .award {
      position: absolute;
      top: 28px;
      left: 50px;
      width: 380px;
      height: 276px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url(~images/kv/award_bg2.png) no-repeat center;
      background-size: auto;

      img {
        width: 88px;
        height: 61px;
      }

      span {
        position: absolute;
        bottom: 20px;
        font-size: 24px;
        color: #fff;
        text-align: center;
      }

      &.sorry {
        background-image: none;

        span {
          padding: 0 20px;
          bottom: 90px;
          font-size: 24px;
          color: #666;
        }
      }
    }

    ::v-deep .mask {
      position: absolute;
      top: 18px;
      left: 40px;
      width: 404px;
      height: 294px;
    }

    .skip {
      @h: 32px;
      position: absolute;
      top: 30px;
      left: 50px;
      padding: 0 20px;
      height: @h;
      border-radius: (@h / 2);
      color: #fff;
      font-size: 24px;
      line-height: @h;
      background-color: #418bab;
    }

    .draw-start {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &--disabled {
        filter: grayscale(100%);
        cursor: not-allowed;
      }

      .dialog-btn {
        position: absolute;
        right: 35px;
        bottom: 70px;
        // width: 207px;
        // height: 101px;
        transform: scale(0.9);
        transition: 0.3s;
        // background: url(~images/rewards/btn_start.png) no-repeat 0 0;
        // background-size: 100% 100%;

        &:hover {
          transform: scale(1);
        }
      }

      .text {
        @color: #efd9a9;
        position: absolute;
        right: 65px;
        top: 64px;
        width: 180px;
        margin-top: 15px;
        font-size: 24px;
        line-height: 1.25em;
        color: #724634;
        text-shadow: 0px 0px 2px #cfb695;
        word-break: keep-all;
        text-shadow: 0 -2px 0 @color,
          /*上*/
          2px -2px 0 @color,
          /*右上*/
          2px 0 0 @color,
          /*右*/
          2px 2px 0 @color,
          /*右下*/
          0 2px 0 @color,
          /*下*/
          -2px 2px 0 @color,
          /*左下*/
          -2px 0 0 @color,
          /*左*/
          -2px -2px 0 @color;
        /*左上*/
      }
    }
  }

  .complete-list {
    @width: 745px;

    width: @width;
    min-height: 397px;
    height: auto;
    background-image: url(~images/rank/sub_table_bg.png);

    .row {
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    .col {
      &:nth-child(1) {
        flex: 1 1 (@width / 10 * 4);
      }

      &:nth-child(2) {
        flex: 1 1 (@width / 10 * 3);
      }

      &:nth-child(3) {
        flex: 1 1 (@width / 10 * 3);
      }
    }

    .thead {
      height: 54px;
    }

    .tbody {
      @width2: @width - 30px;

      .row {
        min-height: 38px;
        height: auto;
      }

      .col {
        &:nth-child(1) {
          flex: 1 1 (@width2 / 10 * 4) - 10px;
        }

        &:nth-child(2) {
          flex: 1 1 (@width2 / 10 * 3) - 10px;
        }

        &:nth-child(3) {
          flex: 1 1 (@width2 / 10 * 3) - 10px;
        }
      }
    }
  }

  .refresh {
    position: relative;
    padding-left: 30px;
    margin: 20px auto;
    width: 134px;
    font-size: 28px;
    color: #fff3ba;
    // background: url(~images/rewards/refresh.png) no-repeat 0 center;
    // background-size: 100% 100%;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -10px;
      width: 20px;
      height: 20px;
      background: url(~images/rewards/refresh_icon.png) no-repeat 0 0;
      background-size: 100% 100%;
    }

    &.is-refresh::before {
      animation: rotate 0.6s linear infinite;
    }

    @keyframes rotate {
      to {
        transform: rotateZ(360deg);
      }
    }
  }

  .winning-record {
    position: absolute;
    bottom: -20px;
    right: 34px;
    font-size: 28px;
    line-height: 29px;
    color: #44220b;
  }
}
</style>
